import { DEFAULT_MEDIA_DURATION, PROJECT_MEDIA_TYPES } from 'consts'
import { IAIImageProject } from 'store/types/aiImage'
import { IBaseMediaItem } from 'types/media'

export const convertAiImgToBaseMediaItem = (
  item: IAIImageProject
): IBaseMediaItem => {
  const image = item.images[0]
  const { width, height } = item
  const { filePath, id } = image
  const assetParentId = item.id.toString()

  return {
    path: filePath,
    type: PROJECT_MEDIA_TYPES.aiImage,
    originalWidth: width,
    originalHeight: height,
    duration: DEFAULT_MEDIA_DURATION,
    fileName: `ai-image-${id}`,
    assetId: id.toString(),
    assetParentId
  }
}
